import { render, staticRenderFns } from "./Paintable.vue?vue&type=template&id=2eee4b35&scoped=true&"
import script from "./Paintable.vue?vue&type=script&lang=js&"
export * from "./Paintable.vue?vue&type=script&lang=js&"
import style0 from "./Paintable.vue?vue&type=style&index=0&id=2eee4b35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee4b35",
  null
  
)

export default component.exports